module.exports = __webpack_public_path__ + "static/media/android-logo.54333b4c.png";